// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8 1.5V14M4.75 14H11.25',
  'M2 4.3H3.1C4.86 4.3 6.48 3.88 8 3.1C9.52 3.88 11.14 4.3 12.9 4.3H14',
  'M3.3 4.5V5.25M12.7 4.5V5.25',
  'M3.3 5.45C3.07 5.45 2.89 5.62 2.8 5.86L1.66 8.87C1.16 10.2 1.96 11.6 3.3 11.6C4.64 11.6 5.44 10.2 4.94 8.87L3.8 5.86C3.71 5.62 3.53 5.45 3.3 5.45Z',
  'M12.7 5.45C12.93 5.45 13.11 5.62 13.2 5.86L14.34 8.87C14.84 10.2 14.04 11.6 12.7 11.6C11.36 11.6 10.56 10.2 11.06 8.87L12.2 5.86C12.29 5.62 12.47 5.45 12.7 5.45Z',
];
